import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { captureReferral } from '../lib/referral'

/**
 * Captura `?ref=CODIGO` de qualquer URL pública e armazena em localStorage
 * por 30 dias. Consumido pelo fluxo de signup.
 */
export const useReferralCapture = () => {
  const { search } = useLocation()
  useEffect(() => {
    const params = new URLSearchParams(search)
    const ref = params.get('ref')
    if (ref) captureReferral(ref)
  }, [search])
}
